import angular from 'angular';
import '../core.module';

function campaignTarget(params) {
  const filled = Object.keys(params).filter((key) => params[key]);
  return filled.length
    ? { state: 'app.campaigns', params: { [filled[0]]: params[filled[0]] } }
    : { state: 'app.campaigns' };
}

export const NOTIFICATION_TYPES = {
  'conversation.handoff_human': {
    icon: 'message-circle',
    tone: 'warning',
    text: (payload) => `${payload.contactName || 'Um contato'} está aguardando atendimento humano.`,
    target: () => ({ state: 'app.conversations' })
  },
  'template.approved': {
    icon: 'check-circle',
    tone: 'success',
    text: (payload) =>
      `A Meta aprovou a mensagem "${payload.templateName || 'template'}". A campanha já pode ser enviada.`,
    target: (payload) => campaignTarget({ template: payload.templateId })
  },
  'template.rejected': {
    icon: 'alert-circle',
    tone: 'danger',
    text: (payload) =>
      `A Meta rejeitou a mensagem "${payload.templateName || 'template'}". Edite e envie de novo.`,
    target: (payload) => campaignTarget({ template: payload.templateId })
  },
  'campaign.completed': {
    icon: 'send',
    tone: 'info',
    text: (payload) =>
      `Campanha "${payload.campaignName || ''}" concluída: ${payload.sent || 0} enviada(s), ${payload.failed || 0} falha(s).`,
    target: (payload) => campaignTarget({ campanha: payload.campaignId })
  },
  'conversation.waiting': {
    icon: 'clock',
    tone: 'warning',
    text: (payload) =>
      payload.waitingFor === 'us'
        ? `${payload.contactName || 'Um cliente'} aguarda nossa resposta há mais de ${payload.hours || 5} horas.`
        : `${payload.contactName || 'Um cliente'} não responde há mais de ${payload.hours || 5} horas.`,
    target: (payload) => ({
      state: 'app.conversations',
      params: { conversa: payload.conversationId }
    })
  },
  'leads.import_completed': {
    icon: 'users',
    tone: 'info',
    text: (payload) =>
      `Importação de leads concluída: ${payload.created || 0} novo(s), ${payload.updated || 0} atualizado(s), ${payload.skipped || 0} ignorado(s).`,
    target: () => ({ state: 'app.crm', params: { aba: 'leads' } })
  }
};

export const REMINDER_ICONS = {
  campaign: 'send',
  agent: 'cpu',
  batch: 'layers'
};

function reminderType(record) {
  if (!record.type || record.type.indexOf('reminder.') !== 0) return null;
  const eventType = record.type.slice('reminder.'.length);
  const group = eventType.indexOf('campaign.batch') === 0 ? 'batch' : eventType.split('.')[0];
  const failed = /failed|cancelled/.test(eventType);
  return {
    icon: REMINDER_ICONS[group] || 'bell',
    tone: failed ? 'danger' : eventType === 'agent.handoff_human' ? 'warning' : 'info',
    text: (payload) => payload.text || payload.title || 'Lembrete',
    target: (payload) => payload.target || null
  };
}

export function toNotification(record) {
  const type = NOTIFICATION_TYPES[record.type] || reminderType(record);
  const payload = record.payload || {};
  return {
    id: record.id,
    type: record.type,
    icon: type ? type.icon : 'bell',
    tone: type ? type.tone : 'neutral',
    text: type ? type.text(payload) : record.type,
    target: type ? type.target(payload) : null,
    conversationId: payload.conversationId || null,
    title: payload.title || null,
    reminderName: payload.reminderName || null,
    read: Boolean(record.read_at),
    createdAt: record.created_at
  };
}

/** Notificações persistentes (sino do topbar) — diferente de NotificationService (toasts).
 * Consome /notifications, que já existia como modelo no schema mas nunca tinha API. */
class NotificationsApiService {
  constructor($http, API_BASE_URL) {
    this.$http = $http;
    this.API_BASE_URL = API_BASE_URL;
  }

  list() {
    return this.page(1, 30).then((result) => result.items);
  }

  page(page = 1, pageSize = 20) {
    return this.$http
      .get(`${this.API_BASE_URL}/notifications`, { params: { page, pageSize } })
      .then((response) => ({
        items: response.data.items.map(toNotification),
        total: response.data.total || 0
      }));
  }

  unreadCount() {
    return this.$http
      .get(`${this.API_BASE_URL}/notifications/unread-count`)
      .then((response) => response.data.count);
  }

  markRead(id) {
    return this.$http.patch(`${this.API_BASE_URL}/notifications/${id}/read`).then(() => true);
  }

  markAllRead() {
    return this.$http.patch(`${this.API_BASE_URL}/notifications/read-all`).then(() => true);
  }
}

NotificationsApiService.$inject = ['$http', 'API_BASE_URL'];

angular.module('app.core').service('NotificationsApiService', NotificationsApiService);

export default NotificationsApiService;
